export default "__VITE_ASSET__HwTAgp$k__"